import axios from 'axios';
import toast from 'react-hot-toast';
import { useMutation, useQuery } from 'react-query';
import { useSetRecoilState } from 'recoil';
import { isLoggedInState } from '../atoms/user';
import Account from '../types/account';
import { AccountRole } from '../types/account-role';
import { ACCOUNTS_URL, BASE_URL, LOGIN_URL, PROFILE_URL } from './urls';

const apiClient = axios.create({
  baseURL: BASE_URL
});

// apiClient.interceptors.response.use(
//   response => response,
//   error => {

//     if (window.location.pathname !== '/login' && error.response.status === 401) {
//       localStorage.clear()
//       window.location.href = '/login';
//       toast.error('نشست کاری شما به اتمام رسید، لطفا دوباره وارد شوید')

//     }
//   })

export function useLogin() {
  return useMutation(({ phoneNumber, password }: { phoneNumber?: string; password?: string }) =>
    apiClient.post(LOGIN_URL, { phoneNumber, password })
  );
}

export function useCreateAccount() {
  return useMutation(
    ({
      phoneNumber,
      email,
      fullName,
      role,
      password
    }: {
      phoneNumber?: string;
      email?: string;
      fullName?: string;
      role?: AccountRole;
      password?: string;
    }) => apiClient.post(ACCOUNTS_URL, { phoneNumber, email, fullName, role, password }, {
      headers: { authorization: localStorage.getItem('AUTH_TOKEN') ?? '' }
    })
  );
}

export const useGetProfile = () => {
  return useQuery(
    'profile',
    async () => {
      const res = await apiClient.get(PROFILE_URL, {
        headers: { authorization: localStorage.getItem('AUTH_TOKEN') ?? '' }

      });
      return res.data;
    },
    {}
  );
};

export const useGetNormalAccounts = () => {
  return useQuery(
    'normal-accounts',
    async () => {
      const res = await apiClient.get<Account[]>(ACCOUNTS_URL + 'normal', {
        headers: { authorization: localStorage.getItem('AUTH_TOKEN') ?? '' }
      });
      return res.data;
    },
    {}
  );
};

export const useGetAllAccounts = () => {
  return useQuery(
    'all-accounts',
    async () => {
      const res = await apiClient.get<Account[]>(ACCOUNTS_URL, {
        headers: { authorization: localStorage.getItem('AUTH_TOKEN') ?? '' }
      });
      return res.data;
    },
    {}
  );
};

export function useLogout() {
  const setLoggedIn = useSetRecoilState(isLoggedInState);

  return () => {
    setLoggedIn(false);
    localStorage.clear();
  };
}
